import { SET_HOME_LINK } from '../actions/laboratory';

export interface LaboratoryRootState {
  homeLink: string;
}

const baseState = {
  homeLink: '/'
};

export default function (state: LaboratoryRootState = baseState, action: any) {
  switch (action.type) {
    case SET_HOME_LINK:
      return Object.assign({}, state, {
        homeLink: action.link
      });
    default:
      return state;
  }
}
